import React from "react";
import type { RouteComponentProps } from "react-router-dom";

import type { Task, TaskType } from "@/core/types";
import { TaskTypeEnum } from "@/core/constants";

import { UpdatedPoliciesConsent } from "../UpdatedPoliciesConsent/UpdatedPoliciesConsent";

import "./styles.scss";

type LoginTasksProps = RouteComponentProps<{ task_name: TaskType }> & {
  onTaskCompleted: (task: Task) => void;
  task: Task;
};

export function LogInTasks({ match, onTaskCompleted, task }: LoginTasksProps) {
  const taskType = match.params.task_name;

  return <>{renderTaskComponent({ onTaskCompleted, task, taskType })}</>;
}

type RenderProps = {
  onTaskCompleted: (task: Task) => void;
  task: Task;
  taskType: TaskType;
};

function renderTaskComponent({ onTaskCompleted, taskType, task }: RenderProps) {
  switch (taskType) {
    case TaskTypeEnum.UpdatedChildConsent:
    case TaskTypeEnum.UpdatedConsentRequired:
    case TaskTypeEnum.UpdatedPolicies:
      return <UpdatedPoliciesConsent onTaskCompleted={onTaskCompleted} task={task} />;

    default:
      return null;
  }
}
